export default __webpack_public_path__ + "static/media/new-play.46b5fbb3.svg";